import { Injectable } from '@angular/core';
import { HttpClient, HttpContext } from '@angular/common/http';
import { Observable } from 'rxjs';

import { serviceurl } from 'src/app/constant/constant';
import { SKIP_ERROR_TOAST } from 'src/app/interceptors/error.interceptor';
import { Coupon } from './marketplace.models';
import { Paginated, unwrapPage } from './pagination.util';

/** What a seller fills in to create a shop discount code. */
export interface CouponDraft {
  code: string;
  discount_type: 'percent' | 'fixed';
  discount_value: string | number;
  max_redemptions: number | null;
  expires_at: string | null;
}

/** A seller's own discount codes (My shop → Coupons). */
@Injectable({ providedIn: 'root' })
export class CouponService {
  private apiUrl = serviceurl + 'api/v1/coupons';
  /** The forms show their own error messages. */
  private quiet = { context: new HttpContext().set(SKIP_ERROR_TOAST, true) };

  constructor(private http: HttpClient) {}

  list(): Observable<Coupon[]> {
    return this.http.get<Paginated<Coupon> | Coupon[]>(`${this.apiUrl}/`).pipe(unwrapPage<Coupon>());
  }

  create(draft: CouponDraft): Observable<Coupon> {
    return this.http.post<Coupon>(`${this.apiUrl}/`, draft, this.quiet);
  }

  update(id: number, changes: Partial<CouponDraft & { active: boolean }>): Observable<Coupon> {
    return this.http.patch<Coupon>(`${this.apiUrl}/${id}/`, changes, this.quiet);
  }

  remove(id: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${id}/`, this.quiet);
  }
}
